import { createElement } from 'react'

// The ONE place the chrome's icon size and colour rule live.
//
// Lucide bodies already draw with stroke="currentColor" and their own stroke
// width, so an icon takes the colour of the button it sits in — active,
// hover, disabled and dark mode all keep working with no extra code here.
//
// Written with createElement, not JSX, so this package ships unbuilt: a
// plugin's own vite build compiles it along with the plugin's source, and
// `react` resolves to the ONE copy the federation host shares.

// pointer-events-none: the button, never the icon, takes the press. An icon re-rendered between
// mousedown and mouseup lost the click on the chart row delete button (2026-10-05, commit 92085b3).
const DEFAULT_SIZE = 18

/** Wraps one Lucide body into a component. Called only by generated.js. */
export function icon(body, name) {
  function OmniIcon({ size = DEFAULT_SIZE, className = '', ...rest }) {
    return createElement('svg', {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      'data-icon': name,
      'aria-hidden': 'true',
      focusable: 'false',
      className: `pointer-events-none inline-block shrink-0 align-middle ${className}`.trim(),
      dangerouslySetInnerHTML: { __html: body },
      ...rest,
    })
  }
  OmniIcon.displayName = `Icon(${name})`
  OmniIcon.iconName = name
  return OmniIcon
}
